import React from "react";
import { FormControlStyles } from "../../components/ui/FormControlStyles";
import { Header } from "../../features/kquant/components/Header";
import { HeroSection } from "./HeroSection";
import { StrategiesSection } from "./StrategiesSection";

export default function MyQuantFlowsPage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-100 text-slate-800">
      <FormControlStyles theme="light" />

      <div className="relative mx-auto max-w-[1280px] px-8">
        <Header />

        <main className="pb-16">
          <HeroSection />
          <StrategiesSection />
        </main>
      </div>
    </div>
  );
}
